export const aiAgentCenterMessages = {
  onGoing: 'Đang diễn ra',
  historiesSupport: 'Lịch sử hỗ trợ',
  calls: 'Cuộc gọi',
  chat: 'Cuộc chat',
  countActive: (count: number, max: number) => `ĐTV AI đang hoạt động: (${count}/${max})`,
  channel: 'Kênh',
  channelChat: ' Kênh chat',
  selectCallSession: 'Chọn một cuộc gọi để xem nội dung trao đổi giữa Điện thoại viên AI và khách hàng',
  turnOffWarning: 'Tắt cảnh báo',
  chatInfo: 'Thông tin cuộc chat',
  callInfo: 'Thông tin cuộc gọi',
  contactInfo: 'Thông tin người liên hệ',
  contactProfile: 'Hồ sơ người liên hệ',
  agentSupported: 'Điện thoại viên hỗ trợ',
  ticketCreated: 'Phiếu đã tạo',
  pendingTickets: 'Chờ tiếp nhận',
  processingTime: 'Thời gian xử lý',
  processingTickets: 'Đang xử lý',
  turnOnWarning: 'Bật cảnh báo',
  selectChatSession: 'Chọn một cuộc chat để xem nội dung trao đổi giữa Điện thoại viên AI và khách hàng',
  intervention: 'Can thiệp',
  callChanel: 'Kênh gọi',
  callCount: (count: number) => `${count} cuộc gọi`,
  chatCount: (count: number) => `${count} cuộc chat`,
  noContactInfo: 'Không có thông tin người liên hệ',
  interventionChat: 'Can thiệp cuộc chat',
  interventionChatWarning:
    'Thao tác này sẽ ngắt quá trình hỗ trợ của điện thoại viên AI và bạn sẽ tiếp nhận cuộc chat.',

  interventionCall: 'Can thiệp cuộc gọi',
  interventionCallWarning: 'Thao tác này sẽ ngắt quá trình hỗ trợ của điện thoại viên AI và bạn sẽ tiếp nhận cuộc gọi.',
  interceptChatSuccess: 'Can thiệp cuộc chat thành công',
  alertCallSuccess: 'Cập nhật cảnh báo cuộc gọi thành công',
  supporting: 'Đang hỗ trợ',
  loadingContact: 'Đang tải thông tin liên hệ',
  loadingContactSentiment: 'Đang tải hành vi khách hàng',
  keywordCall: 'Tìm theo số điện thoại',
  keywordChat: 'Tìm theo tên khách hàng',
};
